
import React from 'react';
import { Input } from '../../../../../components/ui/input';
import { BaseFieldPreviewProps } from './previewUtils';

const TimeFieldPreview: React.FC<BaseFieldPreviewProps> = ({ field, renderDescription }) => {
  return (
    <div>
      {renderDescription()}
      <Input type="time" disabled className="bg-white" />
    </div>
  );
};

export default TimeFieldPreview;
